var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fy_header'),_vm._v(" "),_c('fy_banner'),_vm._v(" "),_c('fy_index_title'),_vm._v(" "),_vm._l((_vm.containerList),function(item,index){return _c('fy_container',{key:index,attrs:{"container":item}})}),_vm._v(" "),_c('fy_sponsor'),_vm._v(" "),_c('fy_footer')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1306c479","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = null
// module chunks = 